import React from 'react'
import jwt from 'jwt-decode'
import ReglasDataTable from '../Components/ReglasDataTable'
import Loading from '../Components/Loading'
import Paginator from '../Components/Paginator'
import ModalFecha from '../Components/ModalFecha'
import ModalEstado from '../Components/ModalEstado'
import { DocumentoService } from '../../Domain/Services/Documento.service'
import CostosPG from '../Components/CostosPG'

import '../Assets/Css/DTDocumento.css'

interface IReporte{
    FechaInicio: Date
    FechaFin: Date
    IdUsuario: number
}

interface IPaginado{
    NumeroPagina : number
    RegistrosPagina : number
    NumeroPaginas : number
    fil_CodigoPlan : string
    fil_IDPlan : string
    fil_Categoria : string
    fil_Marca : string
    fil_TipoPlan : string
    fil_EANBonificado : string
    fil_EstadoRegla: number
    fil_Mes: string
    fil_Anio: number
    fil_EAN: string
    fil_Costo: number
    fil_FechaInicio: Date | null
    fil_FechaFin: Date | null
}

interface ISniper{
    code: number,
    name: string
}

interface IRegistrosPagina{
    RegistrosPagina: number
}

interface IProps {
}

interface IState {
    Loading: boolean
    IsLoading: boolean
    HEmpresa: {PKID: number, Nombre: string}
    Paginado: IPaginado
    Documento: Array<object>
    Empresa: Array<ISniper>
    ActiveIndex: number
    RegistrosPagina: IRegistrosPagina
    ModalIsOpenFechas: boolean
    Reporte: IReporte
    ModalIsOpen: boolean
    Regla: Array<object>
    Costos: Array<object>
    SidebarCollapsed: boolean
}

export default class Documento extends React.Component<IProps, IState> {

    cPaginado = {
        NumeroPagina : 1,
        RegistrosPagina : 50,
        NumeroPaginas : 0,
        fil_CodigoPlan : '',
        fil_IDPlan : '',
        fil_Categoria : '',
        fil_Marca : '',
        fil_TipoPlan : '',
        fil_EANBonificado : '',
        fil_EstadoRegla: -2,
        fil_Mes: '',
        fil_Anio: 0,
        fil_EAN: '',
        fil_Costo: 0,
        fil_FechaInicio: null,
        fil_FechaFin: null
    }

    cReporte = {
        FechaInicio: new Date(),
        FechaFin: new Date(),
        IdUsuario: 0
    }

    constructor(props : any){
        super(props)
        this.state = {
            Loading: false,
            IsLoading: false,
            HEmpresa: { PKID: 0, Nombre: ''},
            Paginado: this.cPaginado,
            Documento: [],
            Empresa: [],
            ActiveIndex: 0,
            RegistrosPagina: { RegistrosPagina : 50},
            ModalIsOpenFechas: false,
            Reporte: this.cReporte,
            ModalIsOpen: false,
            Regla: [],
            Costos: [],
            SidebarCollapsed: false
        }
    }

    componentDidMount(){
        this.CargarEmpresas()      
    }

    componentDidUpdate() {
        window.scrollTo(0, 0);
     }
    
    CargarEmpresas(){
        var Token : string | null = localStorage.getItem('TOKEN-UN1FL3X')
        if(Token){
            var Decoded : any = jwt(Token)
            var Usuario = {
                PKID : Decoded.sub
            }
            this.setState({IsLoading: true})
            DocumentoService.CargarEmpresas(Usuario)
            .then( (data : any) => {
                if(data.success){
                    var info = JSON.parse(data.data);
                    var aEmpresa : any = []
                    Object.keys(info).forEach(function(key){
                        var iEmpresa = {
                            code: info[key].PKID,
                            name: info[key].Nombre,
                        }
                        aEmpresa.push(iEmpresa);
                    });
                    var cEmpresa = {
                        PKID : aEmpresa[0].code,
                        Nombre: aEmpresa[0].name
                    }
                    this.setState({
                        Empresa: aEmpresa,
                        HEmpresa: cEmpresa,
                    }, () => {
                        this.CargarHojaDocumento()
                    })
                }else{
                    alert(data.data)
                }
            })
            .finally( () => {
                this.setState({IsLoading: false})
            })
        }
    }

    CargarHojaDocumento(){
        var lElemento = {
            Empresa : this.state.HEmpresa,
            Paginado : this.state.Paginado
        }
        this.setState({Loading: true})
        {lElemento.Empresa.Nombre == 'LP'?
        DocumentoService.CargarCostosPG(lElemento)
        .then( (data : any) => {
            if(data.success){
                this.setState((prevState) => ({
                    Documento: JSON.parse(data.data),
                    Paginado: {...JSON.parse(data.data)[0].Paginado, fil_FechaInicio: prevState.Paginado.fil_FechaInicio, fil_FechaFin: prevState.Paginado.fil_FechaFin}
                }))
            }
        })
        .finally( () => {
            this.setState({Loading: false})
        })
        :
        DocumentoService.CargarReglaEmpresa(lElemento)
        .then( (data : any) => {
            if(data.success){
                this.setState((prevState) => ({
                    Documento: JSON.parse(data.data),
                    Paginado: {...JSON.parse(data.data)[0].Paginado, fil_FechaInicio: prevState.Paginado.fil_FechaInicio, fil_FechaFin: prevState.Paginado.fil_FechaFin}
                }))
            }
        })
        .finally( () => {
            this.setState({Loading: false})
        })
    }
        
    }
    
    HandleFileUpload = (Event : any, RefFile : any, Origen : any)=> {
        var Token : string | null= localStorage.getItem('TOKEN-UN1FL3X')
       if (Origen == 'Costos'){
        if(Token){
            var Decoded : any = jwt(Token)
            const FData = new FormData()
            FData.append("Files",Event.files[0]);
            FData.append("Usuario",Decoded.sub);
            this.setState({
                    Loading: true
            },() => {
                DocumentoService.SubirArchivoCostos(Event,FData)
                .then( (data : any) => {
                    alert(JSON.parse(data.data).Descripcion)
                    if(data.success) window.location.reload()
                })
                .catch((error) => {
                    alert(error)
                })
                .finally( () => {
                    this.setState({
                        Loading: false
                    })
                })
            })
        }
        RefFile.current.files = ''
        RefFile.current.state.files = ''
    }else{
        if(Token){
            var Decoded : any = jwt(Token)
            const FData = new FormData()
            FData.append("Files",Event.files[0]);
            FData.append("Usuario",Decoded.sub);
            this.setState({
                    Loading: true
            },() => {
                DocumentoService.SubirArchivo(Event,FData)
                .then( (data : any) => {
                    alert(JSON.parse(data.data).Descripcion)
                    if(data.success) window.location.reload()
                })
                .catch((error) => {
                    alert(error)
                })
                .finally( () => {
                    this.setState({
                        Loading: false
                    })
                })
            })
        }
        RefFile.current.files = ''
        RefFile.current.state.files = ''
    }
    }

    ToggleSidebar = () => {
        this.setState({ SidebarCollapsed: !this.state.SidebarCollapsed })
    }

    SelectEmpresa = (index: number) => {
        this.setState({
            ActiveIndex: index,
            HEmpresa: {
                PKID: this.state.Empresa[index].code,
                Nombre: this.state.Empresa[index].name
            },
            Documento: [],
            Paginado: this.cPaginado,
            RegistrosPagina: { RegistrosPagina: 50 },
            Reporte: this.cReporte
        }, () => this.CargarHojaDocumento())
    }

    HandlePreviousLL = () =>{
        this.setState({
            Paginado:{
                ...this.state.Paginado,
                NumeroPagina: 1,
                RegistrosPagina: 50,
                NumeroPaginas: 0
            }
        }, () => this.CargarHojaDocumento())
    }

    HandlePrevious = () =>{
        this.setState({
            Paginado:{
                ...this.state.Paginado,
                NumeroPagina: this.state.Paginado.NumeroPagina - 1
            }
        }, () => this.CargarHojaDocumento())
    }

    HandleFollowing = () =>{
        this.setState({
            Paginado:{
                ...this.state.Paginado,
                NumeroPagina: this.state.Paginado.NumeroPagina + 1
            }
        }, () => this.CargarHojaDocumento())
    }

    HandleFollowingLL = () =>{
        this.setState({
            Paginado:{
                ...this.state.Paginado,
                NumeroPagina: this.state.Paginado.NumeroPaginas
            }
        }, () => this.CargarHojaDocumento())
    }    

    OnRegistroChange = (Event : any) =>{
        this.setState({
            Paginado:{
                ...this.state.Paginado,
                NumeroPagina: 1,
                RegistrosPagina: Event.value.RegistrosPagina,
            },
            RegistrosPagina: Event.value
        }, () => this.CargarHojaDocumento())
    }

    OnChangeReporte = (Event : any) => {
        this.setState({
            Reporte:{
                ...this.state.Reporte,
                [Event.target.name]: Event.target.value
            }
        })
    }

    HandleSelectRow = (Regla : any) => {   
        this.setState({
            Regla: Regla.EstadoRegla
        },() => {
            this.setState({
                ModalIsOpen: true
            })
        })
    };

    AplicarFiltroFechas = (Event : any) =>{
        Event.preventDefault()
        this.setState({
            ModalIsOpenFechas: false,
            Paginado:{
                ...this.state.Paginado,
                fil_FechaInicio: this.state.Reporte.FechaInicio,
                fil_FechaFin: this.state.Reporte.FechaFin
            }
        }, () => this.CargarHojaDocumento())
    }

    render(){
        var lEmpresa = this.state.Empresa[this.state.ActiveIndex]
        var DocumentoFiltrado = this.state.Documento
        if (this.state.Paginado.fil_FechaInicio && this.state.Paginado.fil_FechaFin) {
            DocumentoFiltrado = this.state.Documento.filter((item: any) => {
                var fInicio = new Date(item.FechaInicio)
                var fFin = new Date(item.FechaFin)
                return fInicio >= this.state.Paginado.fil_FechaInicio! && fFin <= this.state.Paginado.fil_FechaFin!
            })
        }

        return (
            <>
                {this.state.IsLoading ? 
                    <Loading Load={this.state.IsLoading}/>
                    :
                    <div className="dashboard">
                        <aside className={`dashboard-sidebar ${this.state.SidebarCollapsed ? 'collapsed' : ''}`}>
                            <div className="sidebar-header">
                                <i className="pi pi-building"></i>
                                <span className="sidebar-header-text">Empresas</span>
                            </div>
                            <nav className="sidebar-nav">
                                {this.state.Empresa.map((emp: ISniper, index: number) =>
                                    <button
                                        key={emp.code}
                                        className={`sidebar-item ${this.state.ActiveIndex === index ? 'active' : ''}`}
                                        onClick={() => this.SelectEmpresa(index)}>
                                        <span className="sidebar-item-icon">
                                            {emp.name === 'LP' ?
                                                <i className="pi pi-chart-bar"></i>
                                                :
                                                <i className="pi pi-tag"></i>
                                            }
                                        </span>
                                        <span className="sidebar-item-label">{emp.name}</span>
                                        {this.state.ActiveIndex === index &&
                                            <span className="sidebar-item-indicator"></span>
                                        }
                                    </button>
                                )}
                            </nav>
                        </aside>
                        <main className="dashboard-main">
                            {lEmpresa && (
                                <>
                                    <div className="dashboard-header">
                                        <div className="dashboard-header-left">
                                            <button className="sidebar-toggle" onClick={this.ToggleSidebar}>
                                                <i className={`pi ${this.state.SidebarCollapsed ? 'pi-angle-right' : 'pi-angle-left'}`}></i>
                                            </button>
                                            <h2 className="dashboard-title">
                                                {lEmpresa.name === 'LP' ? 'Costos PG' : 'Reglas de Promociones'}
                                            </h2>
                                            <span className="dashboard-company"><i className="pi pi-building" style={{fontSize: '12px'}}></i>{lEmpresa.name}</span>
                                        </div>
                                    </div>
                                    <div className="dashboard-content">
                                        {lEmpresa.name == 'LP' ?
                                            <CostosPG
                                                HandleFileUpload = {this.HandleFileUpload}
                                                Costos = {DocumentoFiltrado}
                                                Loading = {this.state.Loading}
                                                HandleSelectRow = {null}
                                                Paginado = {this.state.Paginado}
                                                HideModalFecha = {() => this.setState({ModalIsOpenFechas: true})}/>
                                            :
                                            <ReglasDataTable
                                                HandleFileUpload = {this.HandleFileUpload}
                                                Regla = {DocumentoFiltrado}
                                                Loading = {this.state.Loading}
                                                HandleSelectRow = {this.HandleSelectRow}
                                                Paginado = {this.state.Paginado}/>
                                        }
                                        <div className="dashboard-paginator">
                                            <Paginator
                                                Paginado= {this.state.Paginado}
                                                HandlePreviousLL= {this.HandlePreviousLL}
                                                HandlePrevious= {this.HandlePrevious}
                                                HandleFollowing= {this.HandleFollowing}
                                                HandleFollowingLL= {this.HandleFollowingLL}
                                                RegistrosPagina= {this.state.RegistrosPagina}
                                                OnRegistroChange= {this.OnRegistroChange}/>
                                        </div>
                                        {lEmpresa.name != 'LP' &&
                                            <ModalEstado
                                                Modal = {this.state.ModalIsOpen}
                                                EstadoRegla = {this.state.Regla} 
                                                HideModal = {() => this.setState({ModalIsOpen: false})}/>
                                        }
                                        <form onSubmit={this.AplicarFiltroFechas}>
                                            <ModalFecha
                                                Modal = {this.state.ModalIsOpenFechas}
                                                HideModal = {() => this.setState({ModalIsOpenFechas : false})}
                                                OnChange = {this.OnChangeReporte}
                                                Reporte = {this.state.Reporte}/>
                                        </form>
                                    </div>
                                </>
                            )}
                        </main>
                    </div>
                }
            </>
        )
    }
}
